import type { UserGroupSimple, UserGroupUpdateRq } from '../userGroups.types';

export class UserGroupSimpleModel {
  private readonly _dto: UserGroupSimple;

  constructor(dto?: UserGroupSimple) {
    this._dto = dto ?? {};
  }

  get originDTO(): UserGroupSimple {
    return this._dto;
  }

  get totalMemberCount(): number {
    return this._dto.totalMemberCount ?? 0;
  }

  get name(): string {
    return this._dto.name ?? '';
  }

  get subUserGroupCount(): number {
    return this._dto.subUserGroupCount ?? 0;
  }

  get totalSubscriptionCount(): number {
    return this._dto.totalSubscriptionCount ?? 0;
  }

  get tenantId(): string {
    return this._dto.tenantId ?? '';
  }

  get userGroupCode(): string | undefined {
    return this._dto.userGroupCode;
  }

  get userGroupId(): string {
    return this._dto.userGroupId ?? '';
  }

  get isDeleted(): boolean {
    return this._dto.isDeleted ?? false;
  }

  getUpdateDTO(updateValue: Partial<UserGroupUpdateRq>): UserGroupUpdateRq {
    return {
      description: this._dto.description,
      name: this._dto.name ?? '',
      parentUserGroupId: this._dto.parentUserGroupId,
      userGroupId: this._dto.userGroupId ?? '',
      userGroupCode: this._dto.userGroupCode,
      ...updateValue,
    };
  }
}
